import type { GameState } from '../types';

const KEY = 'bakery-pro:save:v2';

export function loadSave(): GameState | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GameState;
    if (parsed.version !== 2) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSave(state: GameState): void {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function clearSave(): void {
  localStorage.removeItem(KEY);
}
